'use strict';

const propTypes = require('prop-types');
const React = require( 'react' );
const { object } = propTypes;
const createReactClass = require('create-react-class');

const HiddenInputs = createReactClass({
  propTypes: {
    inputs: object
  },

  createHiddenInput( key ) {
    const { inputs } = this.props;
    const value = inputs[ key ];
    if ( value === false ) return null;
    return (
      <input key={ key } type="hidden" value={ value } name={ key } />
    );
  },

  render() {
    const { inputs } = this.props;
    const html = Object.keys( inputs ).map( this.createHiddenInput );
    return (
      <div>
        { html }
      </div>
    );
  }
});

module.exports = HiddenInputs;





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/engines/hiddenInputs.jsx